/*
  Shared, module-level utilities. Stable references so they can be
  referenced from React components without triggering hook-dep warnings.
*/

export function formatDate(iso) {
  if (!iso) return "\u2014";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-AU", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch (error) {
    // Date parsing failed — return the raw ISO so the report still renders.
    if (process.env.NODE_ENV !== "production") {
      console.warn("formatDate: unable to parse ISO timestamp", iso, error);
    }
    return iso;
  }
}
